const STORAGE_KEY = 'timer_guest_write_v1';

function readMap(): Record<string, string> {
  if (typeof sessionStorage === 'undefined') {
    return {};
  }
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? '{}') as Record<string, string>;
  } catch {
    return {};
  }
}

function writeMap(m: Record<string, string>) {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(m));
  } catch {
    // ignore
  }
}

export function getGuestWriteToken(roomId: string | null | undefined): string | null {
  if (!roomId) return null;
  const t = readMap()[roomId];
  return t && t.length > 0 ? t : null;
}

export function getGuestWriteTokenHeaders(roomId: string | null | undefined): Record<string, string> {
  const token = getGuestWriteToken(roomId);
  return token ? { 'x-timer-guest-token': token } : {};
}

export function setGuestWriteToken(roomId: string, token: string): void {
  if (!roomId || !token) return;
  const m = readMap();
  m[roomId] = token;
  writeMap(m);
}

/**
 * Ссылка на панель с ключом: для гостя без `gwt` запись в БД недоступна.
 * (?gwt= в URL синхронизируется в sessionStorage в RoomPage.)
 */
export function withGuestWriteTokenInUrl(relativePath: string, roomId: string): string {
  const t = getGuestWriteToken(roomId);
  if (!t) return relativePath;
  const sep = relativePath.includes('?') ? '&' : '?';
  return `${relativePath}${sep}gwt=${encodeURIComponent(t)}`;
}
